<template>
	<v-dialog
			content-class="wrapperDialogDuties"
			:value="true"
			width="1200"
			hide-overlay
			transition="dialog-bottom-transition"
	>
		<v-card>
			<div class="dialogHead">
				<span class="customersHead-title">{{ dutiesTitle }}</span>
				<button type="button" @click="closeDialog">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>

			<div class="dialogMain">
				<div class="title">{{ department }}</div>
				<div class="infoWrap" v-html="duties"></div>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: "ViewDuties",
	props: {
		duties: String,
		department: String,
		dutiesTitle: {
			type: String,
			default: 'Department responsibilities',
		},
	},
	methods: {
		closeDialog() {
			this.$emit('updateClosePopup');
		},
	},
};
</script>

<style lang="scss">
@import "ViewDuties";
</style>
